/** One shared IntersectionObserver for every lazily-drawn tile in the app —
 * animation preset previews and flipbook page thumbnails. Both only cost
 * something while actually on screen: the previews pause their timeline, the
 * thumbnails skip their (whole-scene) render entirely. */
const visibilityCallbacks = new WeakMap<Element, (visible: boolean) => void>();
let visibilityObserver: IntersectionObserver | null = null;

export const observeVisibility = (
  element: Element,
  callback: (visible: boolean) => void,
) => {
  if (!visibilityObserver) {
    visibilityObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        visibilityCallbacks.get(entry.target)?.(entry.isIntersecting);
      }
    });
  }
  visibilityCallbacks.set(element, callback);
  visibilityObserver.observe(element);
  return () => {
    visibilityCallbacks.delete(element);
    visibilityObserver?.unobserve(element);
  };
};
